(() => {
  const initMultipairSelector = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const scope = root.closest('product-info') || root.closest('.product') || document;
    const packs = Array.from(root.querySelectorAll('[data-pro-sock-pack]'));
    const builder = root.querySelector('[data-pro-sock-builder]');
    const rows = root.querySelector('[data-pro-sock-rows]');
    const status = root.querySelector('[data-pro-sock-status]');
    const variantData = root.querySelector('[data-pro-sock-variant-data]');
    const form = scope.querySelector('product-form form') || scope.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const quantityInput = scope.querySelector('input[name="quantity"]');
    const quantityBlock = quantityInput?.closest('.product-form__quantity');
    const nativeVariantPicker = scope.querySelector('variant-selects, variant-radios');
    const paymentButton = scope.querySelector('.shopify-payment-button');
    const submitButton = form?.querySelector('[name="add"]');
    const submitLabel = submitButton?.querySelector('span') || submitButton;
    const locale = (document.documentElement.lang || 'sv-SE').toLowerCase();
    const isSwedish = locale.startsWith('sv');
    const itemSingular = root.dataset.itemSingular || (isSwedish ? 'par' : 'pair');
    const itemPlural = root.dataset.itemPlural || (isSwedish ? 'par' : 'pairs');
    const itemSingularLabel = itemSingular.charAt(0).toUpperCase() + itemSingular.slice(1);
    const hideNativePicker = root.dataset.hideNativePicker === 'true';
    const hideQuantity = root.dataset.hideQuantity === 'true';
    const lockPackVariant = root.dataset.lockPackVariant === 'true';
    const hideSingleVariantBuilder = root.dataset.hideSingleVariantBuilder === 'true';
    let variants = [];
    let activePack = 1;
    let activeVariantId = '';
    let adding = false;

    try {
      variants = JSON.parse(variantData?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const availableVariants = variants.filter((variant) => variant.available !== false);
    const variantPrices = new Map(variants.map((variant) => [String(variant.id), Number(variant.price)]));
    const currency = window.Shopify?.currency?.active || 'SEK';

    const formatMoney = (cents) => {
      const roundedCents = Math.round(Number(cents) || 0);
      const hasDecimals = roundedCents % 100 !== 0;
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(roundedCents / 100);
    };

    const selectedUnitPrice = () => {
      if (activeVariantId && variantPrices.has(activeVariantId)) return variantPrices.get(activeVariantId);
      const selectedId = String(variantInput?.value || '');
      return variantPrices.get(selectedId) || Number(availableVariants[0]?.price || variants[0]?.price || 0);
    };

    const updatePrices = () => {
      const unitPrice = selectedUnitPrice();
      if (!unitPrice) return;

      root.querySelectorAll('[data-pro-sock-total]').forEach((element) => {
        const quantity = Number(element.dataset.quantity || 1);
        const discount = Number(element.dataset.discount || 0);
        const elementUnitPrice = variantPrices.get(String(element.dataset.priceVariantId || '')) || unitPrice;
        element.textContent = formatMoney(elementUnitPrice * quantity * (100 - discount) / 100);
      });

      root.querySelectorAll('[data-pro-sock-save]').forEach((element) => {
        const quantity = Number(element.dataset.quantity || 1);
        const discount = Number(element.dataset.discount || 0);
        const elementUnitPrice = variantPrices.get(String(element.dataset.priceVariantId || '')) || unitPrice;
        const prefix = isSwedish ? 'Spara' : 'Save';
        element.textContent = `${prefix} ${formatMoney(elementUnitPrice * quantity * discount / 100)}`;
      });
    };

    const setHidden = (element, hidden) => {
      if (!element) return;
      element.hidden = hidden;
      element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      element.style.display = hidden ? 'none' : '';
    };

    const createVariantRows = (quantity) => {
      if (!rows) return;
      const previousIds = Array.from(rows.querySelectorAll('[data-pro-sock-pair-variant]')).map((select) => select.value);
      const defaultId = String(variantInput?.value || availableVariants[0]?.id || '');
      const selectableVariants = lockPackVariant && activeVariantId
        ? availableVariants.filter((variant) => String(variant.id) === activeVariantId)
        : availableVariants;
      rows.replaceChildren();

      for (let index = 0; index < quantity; index += 1) {
        const row = document.createElement('label');
        row.className = 'pro-sock-multipair__row';

        const rowLabel = document.createElement('span');
        rowLabel.className = 'pro-sock-multipair__row-label';
        rowLabel.textContent = `${itemSingularLabel} ${index + 1}`;

        const select = document.createElement('select');
        select.className = 'pro-sock-multipair__select';
        select.setAttribute('data-pro-sock-pair-variant', '');
        select.setAttribute(
          'aria-label',
          isSwedish
            ? `Variant för ${itemSingular} ${index + 1}`
            : `Variant for ${itemSingular} ${index + 1}`
        );

        selectableVariants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.public_title || variant.title;
          select.append(option);
        });

        const preferredId = previousIds[index] || defaultId;
        if (selectableVariants.some((variant) => String(variant.id) === preferredId)) select.value = preferredId;

        row.append(rowLabel, select);
        rows.append(row);
      }
    };

    const updateSubmitLabel = () => {
      if (!submitLabel) return;
      if (!submitLabel.dataset.proSockDefault) submitLabel.dataset.proSockDefault = submitLabel.textContent.trim();

      if (activePack === 3 || activePack === 6) {
        submitLabel.textContent = isSwedish
          ? `Lägg ${activePack} ${itemPlural} i varukorgen`
          : `Add ${activePack} ${itemPlural} to cart`;
      } else {
        submitLabel.textContent = submitLabel.dataset.proSockDefault;
      }
    };

    const applyPack = (quantity, selectedPack = null) => {
      activePack = Number(quantity) || 1;
      const isMixedPack = activePack === 3 || activePack === 6;
      const requestedVariantId = String(selectedPack?.dataset.variantId || '');
      root.dataset.activePack = String(activePack);
      if (status) status.textContent = '';

      if (requestedVariantId && variantPrices.has(requestedVariantId)) {
        activeVariantId = requestedVariantId;
        if (variantInput) {
          variantInput.value = requestedVariantId;
          variantInput.dispatchEvent(new Event('input', { bubbles: true }));
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        activeVariantId = '';
      }

      if (quantityInput) {
        quantityInput.value = String(activePack);
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (builder) builder.hidden = !isMixedPack || hideSingleVariantBuilder;
      setHidden(nativeVariantPicker, hideNativePicker || isMixedPack);
      setHidden(quantityBlock, hideQuantity || isMixedPack);
      setHidden(paymentButton, isMixedPack);

      if (isMixedPack) createVariantRows(activePack);
      updateSubmitLabel();
      updatePrices();
    };

    packs.forEach((pack) => {
      pack.addEventListener('change', () => {
        if (pack.checked) applyPack(pack.value, pack);
      });
    });

    quantityInput?.addEventListener('change', () => {
      const quantity = Number(quantityInput.value || 1);
      const matchingPack = packs.find((pack) => Number(pack.value) === quantity && pack.checked)
        || packs.find((pack) => Number(pack.value) === quantity);
      packs.forEach((pack) => { pack.checked = pack === matchingPack; });

      if (matchingPack && quantity !== activePack) applyPack(quantity, matchingPack);
      if (!matchingPack && activePack !== quantity) {
        activePack = quantity;
        if (builder) builder.hidden = true;
        setHidden(nativeVariantPicker, false);
        setHidden(quantityBlock, false);
        setHidden(paymentButton, false);
        updateSubmitLabel();
      }
    });

    scope.addEventListener('change', () => window.setTimeout(updatePrices, 0));

    form?.addEventListener('submit', async (event) => {
      const handlesFixedVariant = lockPackVariant && Boolean(activeVariantId);
      if (activePack !== 3 && activePack !== 6 && !handlesFixedVariant) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (adding) return;

      const selectedIds = activePack === 3 || activePack === 6
        ? Array.from(rows?.querySelectorAll('[data-pro-sock-pair-variant]') || []).map((select) => select.value)
        : [activeVariantId];
      if (selectedIds.length !== activePack || selectedIds.some((id) => !id)) {
        if (status) status.textContent = isSwedish
          ? `Välj variant för alla ${itemPlural}.`
          : `Choose a variant for all ${itemPlural}.`;
        return;
      }

      const quantities = selectedIds.reduce((result, id) => {
        result[id] = (result[id] || 0) + 1;
        return result;
      }, {});
      const items = Object.entries(quantities).map(([id, quantity]) => ({ id: Number(id), quantity }));

      adding = true;
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('loading');
      }
      if (status) status.textContent = isSwedish
        ? `Lägger till valda ${itemPlural}…`
        : `Adding selected ${itemPlural}…`;

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Cart error');
        }

        window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        adding = false;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        }
        if (status) status.textContent = isSwedish
          ? 'Något gick fel. Kontrollera valen och försök igen.'
          : 'Something went wrong. Check your selections and try again.';
      }
    }, true);

    updatePrices();
    const initialPack = packs.find((pack) => pack.checked) || packs[0];
    if (initialPack) applyPack(initialPack.value, initialPack);
  };

  const initAllMultipairSelectors = (container = document) => {
    container.querySelectorAll('[data-pro-sock-multipair]').forEach(initMultipairSelector);
  };

  initAllMultipairSelectors();
  document.addEventListener('DOMContentLoaded', () => initAllMultipairSelectors());
  document.addEventListener('shopify:section:load', (event) => initAllMultipairSelectors(event.target));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('[data-pro-sock-multipair]')) initMultipairSelector(node);
        initAllMultipairSelectors(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
